import { Stack, Typography } from "@mui/material";
import { StatBoxItem } from "../types/StatBoxItem.ts";

export const StatBox = ({ label, value, description }: StatBoxItem) => (
  <Stack direction={"column"} spacing={1}>
    <Typography variant={"body2"}>{label}</Typography>
    <Typography variant={"h4"} color={"primary.dark"}>
      {value}
    </Typography>
    <Typography variant={"caption"} color={"text.secondary"}>
      {description}
    </Typography>
  </Stack>
);
